import { render, staticRenderFns } from "./ThreadTopicSkeleton.vue?vue&type=template&id=56925d9b&scoped=true"
import script from "./ThreadTopicSkeleton.vue?vue&type=script&lang=ts"
export * from "./ThreadTopicSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./ThreadTopicSkeleton.vue?vue&type=style&index=0&id=56925d9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56925d9b",
  null
  
)

export default component.exports